/*
 * @Description: 用户数据管理
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-12-15 17:13:13
 */
import {
	setAuthToken,
	getAuthToken,
	setAuthUserInfo,
	getAuthUserInfo
} from '@/utils/auth'

export default {
	state: {
		token: getAuthToken(),
		userInfo: getAuthUserInfo(),
		showlogin: false,
	},
	getters: {
		token: state => state.token,
		userInfo: state => state.userInfo,
	},
	mutations: {
		openlogin(state, showlogin) {
			state.showlogin = true
		},
		closelogin(state, showlogin){
			state.showlogin = false
		},
		setToken(state, token) {
			state.token = token
			setAuthToken(token)
		},
		setUserInfo(state, userInfo) {
			var userinfo = userInfo
			if (userinfo.holder_type==1){
				userinfo.username = userinfo.holder_name
			}
			else if (userinfo.holder_type==2) {
				userinfo.username = userinfo.company
			}
			else{
				userinfo.username = userinfo.mobile
			}
			
			state.userInfo = userinfo
			setAuthUserInfo(userInfo)
		},
		logout(state) {
			state.token = null
			state.userInfo = null
			sessionStorage.clear()
			localStorage.clear()
		}
	},
	actions: {},
	modules: {}
}